// UX-S2 — Reduce an axios error to a human-readable string for the toast.
// Precedence: string body → data.message → data.title → data.detail →
// error.message → 'Unexpected error'. Never JSON.stringify the body (an
// object error body would otherwise render as a `{...}` blob in the
// toast). Lives in its own file with zero transitive imports so a unit
// test can pin the precedence without dragging in axios / MSAL.
export const friendlyErrorMessage = (error) => {
  const data = error?.response?.data;
  if (typeof data === 'string') return data;
  if (data && typeof data.message === 'string') return data.message;
  if (data && typeof data.title === 'string') return data.title;
  if (data && typeof data.detail === 'string') return data.detail;
  return error?.message || 'Unexpected error';
};
